<template>
  <v-app>
    <v-container class="fill-height d-flex justify-center align-center" fluid>

      <div class="success-container">
        <div class="success-icon"></div>
        <h1>Başarıyla Kaydedildi!</h1>
        <p>Form başvurunuz başarıyla alınmıştır.</p>
        <br>
        <br>
        <h3>Form Kayıt Numarası</h3>
        {{ getId }}
        <!-- <v-btn color="primary" :to="{ name: 'OutFormViewRun' ,params:{id:$route.params.id} }">Başvuru Sayfası</v-btn> -->
        <!-- <v-btn color="primary" :to="{ name: getDurum, params: { id: idParams } }">Başvuru Sayfası</v-btn> -->
        <!-- <router-link :to="{ name: getDurum, params: { id: idParams } }">
  Başvuru Sayfası
</router-link> -->
<!-- <v-btn color="primary" @click="git">Başvuru Sayfası</v-btn> -->

      </div>

    </v-container>
  </v-app>




</template>
<script>
import router from '@/router';


export default {

  name: 'FormSavedSuccess',
  props: {

    idParams: {
      type: String,
      default: null
    }, 
    dis: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mainUrl: process.env.VUE_APP_URL,

    }

  },
  methods:{
git(){
  let url= this.dis ? "OutFormViewRun" : "formgosterim";
  // router.push({ name: url, params: { id: this.$route.params.id } })
this.$emit("RepeatAppeal");

}
  },
  
  computed: {

    getId() {
      return this.idParams;
     // return this.$route.params.id;
    },
    getDurum(){
       return this.dis ? "OutFormViewRun" : "formgosterim";
    }
  }
}
</script>
<style scoped>
body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #f0f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.success-container {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 40px;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  text-align: center;
  animation: fadeIn 1s ease-out;
}

.success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #4CAF50;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  animation: popIn 0.6s ease-out;
}

.success-icon::before {
  content: "✓";
  font-size: 40px;
  color: white;
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

p {
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
}

a.button {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #4CAF50;
  color: white;
  text-decoration: none;
  transition: background-color 0.3s;
}

a.button:hover {
  background-color: #45a049;
}

@keyframes popIn {
  0% {
    transform: scale(0.6);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>